import Sennheiser from "../src/images/sennheiser.jpeg";
import MacBook from "../src/images/macbook.png";
import IphoneXS from "../src/images/iphonexs.jpg";
import Airpods from "../src/images/airpods.png";
import GalaxyFold from "../src/images/galaxyfold.jpg";
import Msi from "../src/images/msi.jpg";
import DellLaptop from "../src/images/dell_laptop.png";
import Iphone12 from "../src/images/iphone12.jpg";

export const products = [
  {
    productId: "PID1",
    productName: "Sennheiser PC 8",
    price: 60,
    url: Sennheiser,
    inStock: 5,
    category: "Headphones",
    description:
      "Immerse yourself in the virtual environment of games like Unreal Tournament and vocally communicate with your teammates by using this headset and its microphone.",
  },
  {
    productId: "PID2",
    productName: "MacBook Pro",
    price: 800,
    url: MacBook,
    inStock: 5,
    category: "Laptop",
    description:
      "Apple MacBook Pro is a macOS laptop with a 13.30-inch display that has a resolution of 2560x1600 pixels. It is powered by a Core i5 processor and it comes with 12GB of RAM. The Apple MacBook Pro packs 512GB of SSD storage.",
  },
  {
    productId: "PID3",
    productName: "Iphone Xs",
    price: 500,
    url: IphoneXS,
    inStock: 5,
    category: "Phone",
    description:
      "Apple iPhone XS smartphone was launched in September 2018. The phone comes with a 5.80-inch touchscreen display with a resolution of 1125x2436 pixels at a pixel density of 458 pixels per inch (ppi). Apple iPhone XS is powered by a hexa-core Apple A12 Bionic processor. The Apple iPhone XS supports wireless charging, as well as proprietary fast charging.",
  },
  {
    productId: "PID4",
    productName: "AirPods Pro",
    price: 100,
    url: Airpods,
    inStock: 5,
    category: "Headphones",
    description:
      "AirPods Pro have been designed to deliver Active Noise Cancellation for immersive sound, Transparency mode so you can hear your surroundings and a customisable fit for all-day comfort. Just like AirPods, AirPods Pro connect like magic to your iPhone or Apple Watch. And they’re ready to use straight out of the case.",
  },
  {
    productId: "PID5",
    productName: "Samsung Galaxy Fold",
    price: 1680,
    url: GalaxyFold,
    inStock: 5,
    category: "Phone",
    description:
      "Samsung Galaxy Fold smartphone was launched in February 2019. The phone comes with a 7.30-inch touchscreen primary display with a resolution of 1536x2152 pixels at a pixel density of 326 pixels per inch (ppi). It also features a 4.60-inch touchscreen as its second display, with a resolution of 720x1680 pixels at a pixel density of 399 pixels per inch (ppi).",
  },
  {
    productId: "PID6",
    productName: "2020 MSI GF75 Thin Gaming Laptop",
    price: 787,
    url: Msi,
    inStock: 5,
    category: "Laptop",
    description:
      "MSI GF75 Thin is a 17.3-inch gaming laptop that features up to 10th-gen Intel Core i7 processor and NVIDIA GeForce RTX 2060 graphics in a brushed aluminum casing.The GF-series is MSI’s series of affordable gaming laptops with an upper mid-range performance rating.",
  },
  {
    productId: "PID7",
    productName: "Latitude 5511 Laptop",
    price: 2100,
    url: DellLaptop,
    inStock: 5,
    category: "Laptop",
    description:
      "Dell Latitude 5511 is a laptop with a 15.00-inch display that has a resolution of 1920x1080 pixels. It is powered by a Core i7 processor and it comes with 16GB of RAM. The Dell Latitude 5000 5490 packs 500GB of HDD storage.Connectivity options include Bluetooth and it comes with 2 USB ports, HDMI Port ports.",
  },
  {
    productId: "PID8",
    productName: "iphone 12 Pro",
    price: 1091,
    url: Iphone12,
    inStock: 5,
    category: "Phone",
    description:
      "iPhone 12 series offers average 5G and 4G download speeds slower than its competition. An Opensignal report claims smartphones by Samsung, OnePlus, Google, and LG deliver higher average download speeds compared to Apple smartphones.",
  },
];
